(() => {
  const desktop = matchMedia('(min-width: 990px) and (hover: hover)');
  function init() {
    document.querySelectorAll('header-menu').forEach(menu => {
      const details = menu.querySelector('details.mega-menu');
      if (!details || details.dataset.no925Ready) return;
      details.dataset.no925Ready = 'true';
      const summary = details.querySelector('summary');
      let enterTimer, leaveTimer, hoverOpened = false, keyboardOpened = false;
      const close = () => {
        clearTimeout(enterTimer); clearTimeout(leaveTimer);
        details.open = false;
        details.classList.remove('mm-visible');
        summary.setAttribute('aria-expanded', 'false');
        hoverOpened = false; keyboardOpened = false;
      };
      const open = () => {
        document.querySelectorAll('details.mega-menu[open]').forEach(other => {
          if (other !== details) {
            other.open = false;
            other.classList.remove('mm-visible');
            other.querySelector('summary').setAttribute('aria-expanded', 'false');
          }
        });
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => { if (details.open) details.classList.add('mm-visible'); });
      };
      menu.addEventListener('mouseenter', () => {
        if (!desktop.matches) return;
        clearTimeout(leaveTimer);
        enterTimer = setTimeout(() => {
          if (!details.open) { hoverOpened = true; open(); }
        }, 140);
      });
      menu.addEventListener('mouseleave', () => {
        clearTimeout(enterTimer);
        if (!desktop.matches || keyboardOpened) return;
        leaveTimer = setTimeout(close, 240);
      });
      summary.addEventListener('click', event => {
        if (innerWidth < 990) return;
        event.preventDefault(); event.stopImmediatePropagation();
        clearTimeout(enterTimer); clearTimeout(leaveTimer);
        if (details.open && !(hoverOpened && event.detail > 0)) close();
        else { open(); keyboardOpened = event.detail === 0; hoverOpened = false; }
      }, true);
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') { close(); summary.focus(); }
      });
      new MutationObserver(() => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (!details.open) details.classList.remove('mm-visible');
      }).observe(details, {attributes:true, attributeFilter:['open']});
      document.addEventListener('pointerdown', event => {
        if (details.open && !menu.contains(event.target)) close();
      });
      desktop.addEventListener('change', close);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
